<div role="dialog" aria-labelledby="apisLoggingView">
  <div class="modal-header">
    <div class="d-flex align-items-center gap-2 flex-wrap">
      @if (!isBodyOnly) {
        <span class="badge font-13 {{ getMethodBadgeClass() }}">
          {{ item?.method }}
        </span>
        <span class="badge font-13 {{ getStatusBadgeClass() }}">
          {{ item?.statusCode }} — {{ getStatusLabel() }}
        </span>
        <code
          class="text-muted small ms-1"
          [matTooltip]="$safeNavigationMigration(item?.url)"
          style="word-break: break-all; max-width: 480px; display: block"
        >
          {{ item?.url }}
        </code>
      } @else {
        <h5 id="apisLoggingView" class="modal-title mb-0">{{ dialogTitle }}</h5>
      }
    </div>
    <button type="button" class="btn-close ms-auto" (click)="close()"></button>
  </div>

  <div class="modal-body p-0">
    @if (!isBodyOnly && item) {
      <!-- Métricas principais -->
      <div class="row g-0 border-bottom">
        <div class="col-6 p-3 border-end text-center">
          <small class="text-muted d-block mb-1">{{ 'report.apiLoggingsView.duration' | translate }}</small>
          <span class="badge font-13 {{ getPerformanceBadgeClass() }}">
            {{ item?.durationMs ?? ('report.apiLoggingsView.notAvailable' | translate) }} ms
          </span>
          <small class="d-block text-muted mt-1">
            {{ getPerformanceLabel() }}
          </small>
        </div>
        <div class="col-6 p-3 border-end text-center">
          <small class="text-muted d-block mb-1">{{ 'report.apiLoggingsView.dateTime' | translate }}</small>
          <strong class="d-block fs-6">
            {{
              $safeNavigationMigration(item?.createdAt)
                | timezoneDate: "DD/MM/YYYY" : getTimezoneCompanyCurrentUser()
            }}
          </strong>
          <small class="text-muted">
            {{
              $safeNavigationMigration(item?.createdAt)
                | timezoneDate: "HH:mm:ss" : getTimezoneCompanyCurrentUser()
            }}
          </small>
        </div>
      </div>

      <!-- URL completa -->
      <div class="p-3 border-bottom bg-light">
        <small class="text-muted fw-semibold d-block mb-1">{{ 'report.apiLoggingsView.fullUrl' | translate }}</small>
        <code
          class="text-dark"
          style="word-break: break-all; font-size: calc(var(--ct-small-font-size) + 1.12px)"
        >
          {{ item?.url }}
        </code>
      </div>

      <!-- Navegador / Plataforma -->
      @if (getBrowser() || getPlatform()) {
        <div class="p-3 border-bottom">
          <small class="text-muted fw-semibold d-block mb-2">{{ 'report.apiLoggingsView.client' | translate }}</small>
          <div class="table-responsive">
            <table
              class="table table-sm table-borderless mb-0"
              style="font-size: calc(var(--ct-small-font-size) + 1.12px)"
            >
              <tbody>
                @if (getBrowser()) {
                  <tr>
                    <td
                      class="fw-semibold text-muted pe-3"
                      style="white-space: nowrap; width: 1%"
                    >
                      {{ 'report.apiLoggingsView.browser' | translate }}
                    </td>
                    <td>{{ getBrowser() }}</td>
                  </tr>
                }
                @if (getPlatform()) {
                  <tr>
                    <td
                      class="fw-semibold text-muted pe-3"
                      style="white-space: nowrap; width: 1%"
                    >
                      {{ 'report.apiLoggingsView.platform' | translate }}
                    </td>
                    <td>{{ getPlatform() }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }

      <!-- Request Body -->
      @if (item?.requestBody) {
        <div class="p-3 border-bottom">
          <small class="text-muted fw-semibold d-block mb-2">
            <i class="ri-upload-2-line me-1"></i>{{ 'report.apiLoggingsView.requestBody' | translate }}
          </small>
          <pre
            class="bg-light p-2 rounded mb-0"
            style="
              max-height: 220px;
              overflow-y: auto;
              font-size: calc(var(--ct-small-font-size) + 0.48px);
              word-break: break-all;
            "
          >
            {{ formatJson($safeNavigationMigration(item?.requestBody)) }}
            </pre
          >
        </div>
      }

      <!-- Response Body -->
      @if (item?.responseBody) {
        <div class="p-3">
          <small class="text-muted fw-semibold d-block mb-2">
            <i class="ri-download-2-line me-1"></i>{{ 'report.apiLoggingsView.responseBody' | translate }}
          </small>
          <pre
            class="bg-light p-2 rounded mb-0"
            style="
              max-height: 280px;
              overflow-y: auto;
              font-size: calc(var(--ct-small-font-size) + 0.48px);
              word-break: break-all;
            "
          >
            {{ formatJson($safeNavigationMigration(item?.responseBody)) }}
            </pre
          >
        </div>
      }

      @if (!item?.requestBody && !item?.responseBody) {
        <div class="p-3 text-center text-muted">
          <i class="ri-inbox-line font-24 d-block mb-1"></i>
          <small>{{ 'report.apiLoggingsView.noPayload' | translate }}</small>
        </div>
      }
    } @else if (isBodyOnly) {
      <!-- Modo body-only (viewBody) -->
      <div class="p-3">
        <pre
          class="bg-light p-2 rounded mb-0"
          style="
            max-height: 460px;
            overflow-y: auto;
            font-size: calc(var(--ct-small-font-size) + 1.12px);
            word-break: break-all;
          "
        >
          {{ formatJson($safeNavigationMigration(data?.body)) }}
          </pre
        >
      </div>
    }
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="close()">
      {{ 'report.apiLoggingsView.close' | translate }}
    </button>
  </div>
</div>
